import React from 'react'

import s from './styles.module.scss'

import SeasonPrice from '../season-price/SeasonPrice'
import { SeasonPriceModeEnum } from '../season-price/SeasonPriceModeEnum'
import { getLabelLineSeasonPrice } from '../utils/utils'
import {
  PriceObjectOutputDto,
  SeasonEnum,
} from '../../../../../../../../lib/graphql'
import PriceSeasonColorTag from '../../../../../../house-options/shared/components/seasonal-busyness-calendar/components/tag/price-season-color-tag/PriceSeasonColorTag'

const LineSeasonPrice = ({
  season,
  priceObject,
  mode,
  label = 'Tarif',
}: {
  season: SeasonEnum
  priceObject?: PriceObjectOutputDto
  mode: SeasonPriceModeEnum
  label: string
}) => {
  return (
    <div className={s.lineSeasonPrice}>
      <div className={s.seasonContainer}>
        <PriceSeasonColorTag season={season} width={14} height={14} />
        <span>
          {label} {getLabelLineSeasonPrice(season)}
        </span>
      </div>

      <SeasonPrice mode={mode} priceObject={priceObject} />
    </div>
  )
}

export default LineSeasonPrice
